import { format } from "date-fns";

const cellStyle = {
  fontSize: "11px",
  lineHeight: "12px",
  width: 55,
};

// Firestore Timestamps surface as { seconds, nanoseconds } from snapshot listeners
// and as { _seconds, _nanoseconds } after JSON serialization through Cloud Functions.
const toSeconds = (value) => value?.seconds ?? value?._seconds ?? null;

const TimestampCell = ({ value }) => {
  const seconds = toSeconds(value);
  if (seconds === null) return null;

  const date = new Date(seconds * 1000);
  return (
    <div style={cellStyle}>
      {format(date, "MM/dd/yy")}
      <br />
      {format(date, "hh:mm aaa")}
    </div>
  );
};

export default TimestampCell;
